import React, { FC, useEffect, useRef, useState } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { initReactI18next, useTranslation } from "react-i18next";

import LiLanguage from "components/Li/LiLanguage";
import LiAccount from "components/Li/LiAccount";
import { getMessage } from "config/util";
import Recaptcha from "../../components/Recaptcha/Recaptchav2";

import { dashboard, holderadmin, holderuser } from "Navigator/Router_material";
import ReactWOW from "react-wow";
import { post_authout } from "../../stores/Auth/actions";
import Header from "../../views_components/Component/Header";

export default function Contents({ SignUp }) {
  const { propsSignUp, set_propsSignUp, dispatch_post_register, dispatch_message, branch } = SignUp;
  const dispatch = useDispatch();
  const history = useHistory();
  const ref = useRef();
  const [t, i18n] = useTranslation();
  const [recaptcha, set_recaptcha] = useState("");

  const reduce_get_accounts = useSelector((state) => state.reduce_get_accounts);
  const reduce_post_authin = useSelector((state) => state.reduce_post_authin);

  const props = propsSignUp;
  const set_props = set_propsSignUp;

  const la = sessionStorage.getItem("AcceptLanguage");
  const token = reduce_post_authin.token;
  const mail_address = reduce_get_accounts.mail_address;

  return (
    <>
      <div style={{ height: "100vh" }}>
        <main className="main sign bg-animation-brand">
          <div
            className="modal-content rounded-5 shadow"
            style={{
              maxWidth: "450px",
            }}
          >
            <div className="modal-header border-bottom-0">
              <a
                href="#"
                className="navbar-brand modal-title"
                onClick={(e) => {
                  e.preventDefault();
                  history.push({
                    pathname: `/home`,
                  });
                }}
              >
                <h1 className="m-0">
                  <span className="tmty-brand">
                    <img
                      src="/dist/tmty/assets/brand/tomonity-typography.webp"
                      width={118}
                      height="auto"
                      alt="tomonity"
                    />
                  </span>
                </h1>
              </a>
            </div>
            <div className="modal-body pt-0">
              <h2 className="h5 fw-bold mb-3">{t("tomonityアカウントを作成")}</h2>
              <div action="#">
                <div className="col">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control rounded-4"
                      id="floatingInput"
                      placeholder="@name"
                      inputMode="email"
                      required
                      autoFocus
                      value={props.username}
                      onChange={(e) => {
                        const val = e.target.value;
                        set_props({
                          ...props,
                          username: val,
                          display_name: val,
                        });
                      }}
                    />
                    <label htmlFor="floatingInput">{t("アカウント名")}</label>
                  </div>
                </div>
                <label
                  className="form-check-label w-100 flex-grow-1 mb-3"
                  htmlFor="invalidCheck2"
                  
                  style={{ fontSize: 13, opacity: 0.65 }}
                >
                  {t(
                    "英数字のみ　6 文字以上 18 文字以内"
                  )}
                </label>
                <div className="row row-cols-sm-2 g-1">
                  <div className="form-floating mb-3">
                    <input
                      type="email"
                      className="form-control rounded-4"
                      id="floatingInput"
                      placeholder="name@example.com"
                      inputMode="email"
                      required
                      value={props.mail_address}
                      onChange={(e) => {
                        const val = e.target.value;
                        set_props({
                          ...props,
                          mail_address: val,
                        });
                      }}
                    />
                    <label htmlFor="floatingInput">{t("メールアドレス")}</label>
                  </div>
                  <div className="form-floating mb-3">
                    <input
                      type="email"
                      className="form-control rounded-4"
                      id="floatingInput"
                      placeholder="name@example.com"
                      inputMode="email"
                      required
                      value={props.mail_address_confirm}
                      onChange={(e) => {
                        const val = e.target.value;
                        set_props({
                          ...props,
                          mail_address_confirm: val,
                        });
                      }}
                    />
                    <label htmlFor="floatingInput">{t("メールアドレス(確認)")}</label>
                  </div>

                  <div className="form-floating">
                    <input
                      type="password"
                      className="form-control rounded-4"
                      id="floatingPassword"
                      placeholder="Password"
                      required
                      value={props.password}
                      onChange={(e) => {
                        const val = e.target.value;
                        set_props({
                          ...props,
                          password: val,
                        });
                      }}
                    />
                    <label htmlFor="floatingPassword">{t("パスワード")}</label>
                  </div>
                  <div className="form-floating">
                    <input
                      type="password"
                      className="form-control rounded-4"
                      id="floatingPassword"
                      placeholder="Password"
                      required
                      value={props.password_confirm}
                      onChange={(e) => {
                        const val = e.target.value;
                        set_props({
                          ...props,
                          password_confirm: val,
                        });
                      }}
                    />
                    <label htmlFor="floatingPassword">{t("パスワード(確認)")}</label>
                  </div>
                </div>
                <label
                  className="form-check-label w-100 flex-grow-1 mt-1 mb-3"
                  htmlFor="invalidCheck2"
                  style={{ fontSize: 13, opacity: 0.65 }}
                >
                  {t(
                    "英大文字・英小文字・数字それぞれを最低1文字ずつ含み、10 文字以上 32 文字以内にする必要があります。"
                  )}
                </label>
                <div className="form-check mt-3 mb-3 d-flex">
                  <input
                    className="form-check-input me-2"
                    type="checkbox"
                    id="invalidCheck2"
                    required
                    value={props.check}
                    onChange={(e) => {
                      const val = e.target.checked;
                      set_props({
                        ...props,
                        check: val,
                      });
                    }}
                  />
                  <label className="form-check-label w-100 flex-grow-1" htmlFor="invalidCheck2">
                    {t("tomonityの「")}
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        window.open(`https://help.tmty.io/tos/`, "_blank", "noreferrer");
                      }}
                    >
                      {t("利用規約")}
                    </a>
                    {t("」と「")}
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        window.open(`https://help.tmty.io/tos/`, "_blank", "noreferrer");
                      }}
                    >
                      {t("プライバシーポリシー")}
                    </a>
                    {t("」に同意しますか？")}
                  </label>
                </div>
                <Recaptcha set_recaptcha={set_recaptcha} action="login" />
                <button
                  className="btn btn-primary rounded-pill btn-lg w-100"
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();

                    if (props.mail_address !== props.mail_address_confirm) {
                      dispatch_message(t("メールアドレスが異なっています。"), "danger");
                      return;
                    }

                    if (props.password !== props.password_confirm) {
                      dispatch_message(t("パスワードが異なっています。"), "danger");
                      return;
                    }
                    if (!props.check) {
                      dispatch_message(t("重要事項に同意していません。"), "danger");
                      return;
                    }
                    dispatch_post_register(
                      {
                        recaptcha: recaptcha,
                        display_name: props.display_name,
                        username: props.username,
                        mail_address: props.mail_address,
                        password: props.password,
                        // phone_number: props.phone_number_international,
                        // country_code,
                        // referral_code,
                      },
                      () => {
                        history.push({
                          pathname: `/signupcode`,
                        });
                        window.scroll(0, 0);
                      }
                    );
                  }}
                >
                  {t("登録")}
                </button>
                <hr className="my-4" />
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    history.push({
                      pathname: `/signin`,
                    });
                  }}
                  className="btn btn-link w-100 rounded-pill"
                >
                  {t("すでにアカウントをお持ちの方")}
                </a>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}
